import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';
import { FlexJustifyCenter, FlexNoAlign, FlexAlignCenter } from '../../../shared-styles/flex';
import { Link as StyledLink, VerticalCenter, StandardBottomMargin } from '../../../shared-styles';

export const PeekContainer = styled.div`
  height: calc(100% - 50px);
  width: 640px;
  background-color: ${(props) => props.theme.palette.custom.gray};
  margin: ${(props) => `24px 0 0 ${props.theme.spacing(8)}`};
  padding-bottom: ${(props) => props.theme.spacing(20)};
  border-radius: 6px;
  flex: none;
  overflow: hidden;
`;

export const TopContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  padding: ${(props) => props.theme.spacing(20)};
  border-bottom: 2px dashed ${(props) => props.theme.palette.darkGray[50]};
  background-color: ${(props) => (props.locked ? props.theme.palette.gray[50] : 'transparent')};
`;

export const DetailLink = styled(Link)`
  ${FlexNoAlign}
  ${StyledLink}
  text-decoration: none;
`;

export const CardContainer = styled.div`
  height: calc(100% - 60px);
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing(20)};
  padding: ${(props) => `0  ${props.theme.spacing(20)}`};
  overflow: scroll;
  padding-bottom: 50vh;
  > :first-child {
    margin-top: ${(props) => props.theme.spacing(20)};
  }
`;

export const LoadingContainer = styled.div`
  height: calc(100% - 40px);
  display: flex;
  justify-content: center;
  gap: ${(props) => props.theme.spacing(20)};
  padding: ${(props) => `0  ${props.theme.spacing(20)}`};
  overflow: auto;
  padding-bottom: ${(props) => props.theme.spacing(5)};
`;

export const IconContainer = styled.div`
  ${VerticalCenter}
  justify-content: flex-end;
  padding-left: ${(props) => props.theme.spacing(5)};
`;

export const HeaderContent = styled.div`
  ${FlexJustifyCenter};
`;

export const LockIcon = styled.img`
  height: ${(props) => props.height};
  width: ${(props) => props.width};
  margin-right: ${(props) => props.theme.spacing(8)};
`;

export const LoadNotFoundContainer = styled.div`
  ${FlexAlignCenter}
  flex-direction: column;
  height: calc(100% - 50px);
  width: 640px;
  background-color: ${(props) => props.theme.palette.custom.gray};
  margin: ${(props) => `24px 0 0 ${props.theme.spacing(8)}`};
  padding-bottom: ${(props) => props.theme.spacing(20)};
  border-radius: 6px;
  overflow: hidden;
`;

export const LoadNotFoundTitle = styled.p`
  margin: 40px 20px 0px 20px;
  ${StandardBottomMargin}
  font-weight: ${({ theme }) => theme.typography.weight.semiBold};
  font-size: ${({ theme }) => theme.typography.sizes.h2};
`;

export const LoadNotFoundMessage = styled.p`
  font-size: ${({ theme }) => theme.typography.sizes.h2};
  text-align: center;
  margin: 0px 20px;
`;
